import { $api } from "../AxiosInstance";

export class TelegramMetricsService {
  static async getAll() {
    return await $api.get("/api/admin/telegram/metrics");
  }
}
